// extracted by mini-css-extract-plugin
module.exports = {"icon":"StreamDeletionRequestCalloutContainer-icon-2vZ3s","gutter":"StreamDeletionRequestCalloutContainer-gutter-1ImgA"};